import React, { useState } from 'react';
import { KoLoader, KoModal
} from 'packages';

import Category from './category';
import CategoryForm from './category/categoryform';


export default function CategoryTable(form) {

  const [categoryDetails, setCategoryDetails] = useState(false);
  const [isloading] = useState(false);

  return (
    <div className={`tableCard`}>
      <Category/>
      <KoModal
        title="Category Details"
        centered
        open={categoryDetails}
        onClose={() => setCategoryDetails(false)}
        onOk={() => setCategoryDetails(false)}
        width={'90vw'}
        maskClosable={false}
      >
        {isloading ? <KoLoader circle={false} /> : <CategoryForm />}
      </KoModal>

    </div>
  );
}
